import ModalEliminarUsuario from './ModalEliminarUsuario';

export default ModalEliminarUsuario;
